import VueCookies from "vue-cookies";
export default {
	/**
	 * 节流阀
	 * @param {function} callBack 回调函数
	 * @param {string} time 时间戳毫秒
	 * @returns
	 */
	throttle(callBack, time) {
		let timer = null;
		return function () {
			if (!timer) {
				timer = setTimeout(() => {
					callBack();
					timer = null;
				}, time);
			}
		};
	},
	/**
	 * 时间格式化
	 * @param {string} value 时间戳
	 * @returns 时间 2021-01-01 12:00:00
	 */
	timeFormat(value) {
		if (value) {
			let add0 = (m) => {
				return m < 10 ? "0" + m : m;
			};
			var time = new Date(value);
			var y = time.getFullYear();
			var m = time.getMonth() + 1;
			var d = time.getDate();
			var h = time.getHours();
			var mm = time.getMinutes();
			var s = time.getSeconds();
			return (
				y +
				"-" +
				add0(m) +
				"-" +
				add0(d) +
				" " +
				add0(h) +
				":" +
				add0(mm) +
				":" +
				add0(s)
			);
		} else {
			return "";
		}
	},
	/**
	 * 日期格式化
	 * @param {string} value 时间戳
	 * @returns 日期 2021-01-01
	 */
	dateFormat(value, key = "-") {
		if (value) {
			let add0 = (m) => {
				return m < 10 ? "0" + m : m;
			};
			var time = new Date(value);
			var y = time.getFullYear();
			var m = time.getMonth() + 1;
			var d = time.getDate();
			return y + key + add0(m) + key + add0(d);
		} else {
			return "";
		}
	},
	/**
	 * 正整数验证
	 * @param {string} str 验证字符串
	 * @param {number} max 最大值
	 * @returns Boolean
	 */
	positiveInteger(str, max = 100000000) {
		const reg = /^[1-9]\d*$/;
		if (reg.test(str + "")) {
			if (!max || max >= str - 0) {
				return true;
			}
			return false;
		}
		return false;
	},
	/**
	 * 手机号验证
	 * @param {string} phone 手机号
	 * @returns Boolean
	 */
	isPhone(phone = "") {
		if (!/^1[3456789]\d{9}$/.test(phone)) {
			return false;
		}
		return true;
	},
	/**
	 * 身份证验证
	 * @param {string} str 身份证号
	 * @returns Boolean
	 */
	isIdCard(str = "") {
		if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(str)) {
			return false;
		}
		return true;
	},
	/**
	 * 邮箱验证
	 * @param {string} str 邮箱
	 * @returns Boolean
	 */
	isEmail(str = "") {
		if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(str)) {
			return false;
		}
		return true;
	},
	// 获取缓存
	getCache(key) {
		if (window.localStorage.getItem(key)) {
			try {
				return JSON.parse(window.localStorage.getItem(key));
			} catch (err) {
				return window.localStorage.getItem(key);
			}
		} else if (VueCookies.get(key)) {
			try {
				return JSON.parse(VueCookies.get(key));
			} catch (err) {
				return VueCookies.get(key);
			}
		} else {
			return "";
		}
	},
	// 设置缓存
	setCache(key, val) {
		try {
			window.localStorage.setItem(key, JSON.stringify(val));
		} catch (err) {
			window.localStorage.setItem(key, val);
		}

		try {
			VueCookies.set(key, JSON.stringify(val), "100D");
		} catch (err) {
			VueCookies.set(key, val, "100D");
		}
	},
	// 删除key
	removeCache(key) {
		window.localStorage.removeItem(key);
		VueCookies.remove(key);
	},

	formatMoney(cent) {
		const _cent = Number(cent);
		return (_cent || 0).toFixed(2);
	},

	/**
	 * 转换为带千分符的
	 * @param value 原始值
	 * @param flag 金钱符号
	 */
	formatMoneyThousand({ value, flag = "" }) {
		if (!value) return "0";
		let _value = value.toFixed(2);
		_value = String(_value);
		if (_value.includes(".")) {
			// _value = formatMoney(value);
			let _valueArr = _value.split(".");
			_valueArr[0] = _valueArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			_value = _valueArr.join(".");
		} else {
			_value = _value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}
		return `${flag}${_value}`;
	},
};
